export const tokenRefresh = (token: string): boolean => {
  const expireTime = JSON.parse(atob(token.split(".")[1])).exp;
  const date = new Date(expireTime * 1000);
  if (new Date() > date) {
    window.parent.postMessage("refresh token", "*");
    return true;
  }
  return false;
};

export const retrieveTokenFromParent = () => {
  window.parent.postMessage("token", "*");
};

export const tokenRefreshingCheck = async (oldToken: string) => {
  let i = 0;
  // Max waiting 3 seconds to get refreshed token
  while (i < 6) {
    if (oldToken === sessionStorage.getItem("id_token")) {
      await new Promise((resolve) => {
        setTimeout(resolve, 500);
      });
      i++;
    } else {
      break;
    }
  }
};
